export default __webpack_public_path__ + "b5f40e687ccfcc968b4f49efd4d1d983.svg";